import React from 'react';

function PageNotFound({ ...props }) {
    return (
        <div style={{
            width: '100%',
            height: 500,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
        }}>
            <div style={{
                fontSize: 20,
                fontWeight: 'bold',
                color: '#00377d'
            }}>{'404 Not Found'}</div>
            <div>{'This page does not exists or you don\'t have enough rights to view this page'}</div>
        </div>
    )
}



export default PageNotFound